import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";

import { createContext, memo } from "react";
import { useSupportV2Enabled } from "../support-v2/providers/use-support-v2-enabled";

export interface SupportSuiteStatuses {
  supportEnabled: boolean;
  supportV2Enabled: boolean;
}

export const SupportSuiteStatusesContext = createContext<
  SupportSuiteStatuses | undefined
>(undefined);

export const SupportSuiteStatusesProvider = memo(
  function SupportSuiteStatusesProvider({
    children,
  }: {
    children: React.ReactNode;
  }) {
    const team = useRequiredContext(TeamContext);
    const settings = team.settings;

    const supportEnabled = !!settings.support?.enabled;
    const supportV2Load = useSupportV2Enabled();

    if (supportV2Load.pending) {
      return null;
    }

    const supportSuiteStatuses = {
      supportEnabled,
      supportV2Enabled: supportV2Load.value,
    };

    return (
      <SupportSuiteStatusesContext.Provider value={supportSuiteStatuses}>
        {children}
      </SupportSuiteStatusesContext.Provider>
    );
  },
);

export { default as SUPPORT_ICON } from "@redotech/redo-icons/message-text-square-02.svg";
export { default as SUPPORT_ICON_FILLED } from "@redotech/redo-icons/message-text-square-02_filled.svg";
